<app-page [isLoading]="isLoading" [isLoadingTitle]="'Bezig met laden...'">
  <form body *ngIf="formModel" class="needs-validation" [formGroup]="formModel" [id]="htmlFormId">
    <app-card-wrapper [title]="'Card 1'" [id]="1">
      <app-select
        [label]="'Werkjaar'"
        [control]="formModel.ValueRequired"
        [options]="[
          { id: '1', name: '2022' },
          { id: '2', name: '2023' },
        ]"
      >
      </app-select>
      <app-horizontal-text-input [control]="formModel.ValueRequired" [label]="'Volgnummer'">
      </app-horizontal-text-input>
    </app-card-wrapper>

    <app-card-wrapper [title]="'Card 2'" [id]="2" [sidenavLabel]="'Card 2'">
      <app-select [label]="'Keuze'" [control]="formModel.Option" [options]="options"> </app-select>
      <app-select [label]="'Keuze'" [control]="formModel.OptionRequired" [options]="options">
      </app-select>
      <div *ngIf="formModel.OptionRequired.value == 1">
        <app-horizontal-text-input [label]="'Text vereist'" [control]="formModel.ValueRequired">
        </app-horizontal-text-input>
      </div>
      <div *ngIf="formModel.OptionRequired.value == 1">
        <app-horizontal-text-input [label]="'Text'" [control]="formModel.Value">
        </app-horizontal-text-input>
      </div>

      <app-multi-select
        [label]="'Selecteer max. 3 items'"
        [selectedIds]="selectedIds"
        [options]="options"
        [max]="3"
      ></app-multi-select>
      <app-radio-group
        [label]="'Radio buttons'"
        [control]="formModel.Option"
        [groupName]="'group1'"
        [options]="options"
      >
      </app-radio-group>
      <app-radio-group
        [label]="'Checkboxen'"
        [control]="formModel.Option"
        [options]="options"
        [groupName]="'group2'"
        [type]="'checkbox'"
      >
      </app-radio-group>
      <app-radio
        [label]="'Checkbox'"
        [id]="'checkbox'"
        [control]="formModel.Option"
        [type]="'checkbox'"
        [value]="'1'"
      ></app-radio>

      <app-rich-text [label]="'Rich text'" [control]="formModel.Value"></app-rich-text>
    </app-card-wrapper>

    <div class="mt-4 pe-4 text-end">
      <app-button
        (click)="goBack()"
        [type]="ButtonType.link"
        [buttonClass]="'btn-outline-secondary me-3'"
        [iconClass]="'fa-arrow-left text-secondary'"
        [name]="'Terug'"
      ></app-button>
      <app-button
        (click)="saveItem()"
        [iconClass]="'fa-save text-white'"
        [isSaving]="isSaving"
      ></app-button>
    </div>
  </form>

  <ng-container rightNav *ngIf="sidenav && sidenav.length > 0">
    <app-right-nav
      [items]="sidenav"
      webinarUrl="https://www.youtube.com/watch?v=CrufyaDvwlE&t=735s"
    >
      <div class="card">
        <div class="mt-3">
          <div class="mx-3">
            <app-button
              (click)="goBack()"
              [buttonClass]="'btn btn-outline-secondary btn-sm w-100 ms-0 mb-3'"
              [name]="'Terug'"
              [isSaving]="isSaving"
            ></app-button>
          </div>
          <div class="mx-3">
            <app-button
              (click)="saveItem()"
              [buttonClass]="'btn btn-primary btn-sm w-100 ms-0 mb-3'"
              [name]="'Ontvangst inboeken'"
              [isSaving]="isSaving"
            ></app-button>
          </div>
        </div>
      </div>
    </app-right-nav>
  </ng-container>
</app-page>
